import { useState } from 'react';

import { HeaderMainNav, NavigationGroup } from '@/graphql/__generated/sdk';

export function useMenuNavigation() {
	const [currentMenuLevel, setCurrentMenuLevel] = useState<'main' | 'submenu' | 'thirdlevel'>('main');
	const [selectedMainItem, setSelectedMainItem] = useState<HeaderMainNav | null>(null);
	const [selectedSubItem, setSelectedSubItem] = useState<NavigationGroup | null>(null);

	const handleMainItemClick = (item: HeaderMainNav) => {
		const hasSubNav = (item.headerSubNavMenu?.headerSubNavGroupsCollection?.items?.length ?? 0) > 0;
		if (hasSubNav) {
			setSelectedMainItem(item);
			setCurrentMenuLevel('submenu');
		}
	};

	const handleSubItemClick = (group: NavigationGroup) => {
		const hasLinks = (group.linksCollection?.items?.length ?? 0) > 0;
		if (hasLinks) {
			setSelectedSubItem(group);
			setCurrentMenuLevel('thirdlevel');
		}
	};

	const handleBackToMain = () => {
		setCurrentMenuLevel('main');
		setSelectedMainItem(null);
		setSelectedSubItem(null);
	};

	const handleBackToSubmenu = () => {
		setCurrentMenuLevel('submenu');
		setSelectedSubItem(null);
	};

	const resetNavigation = () => {
		handleBackToMain();
	};

	return {
		currentMenuLevel,
		selectedMainItem,
		selectedSubItem,
		handleMainItemClick,
		handleSubItemClick,
		handleBackToMain,
		handleBackToSubmenu,
		resetNavigation,
	};
}
